/**
 * Header slider
 */
class Mokolove_Header {
    constructor () {
        if ($('.slideshow').length) {
            this.init();
        }
    }

    init () {
        this.UI = {
            list: $('.slideshow .slider-list'),
            dots: $('.slideshow .slider-dots li')
        };

        this.current = 1;
        this.skipFrame = false;

        this.UI.dots.each((i, dot) => {
            dot = $(dot);
            dot.on('click', e => {
                this.skipFrame = true;
                this.UI.dots.removeClass('is-active');
                dot.addClass('is-active');
                this.current = parseInt(dot.attr('data-index'), 10);
                this.UI.list.attr('data-current', this.current);
            });
        });

        setTimeout(() => {
            this.autoanimate();
        }, 4000);
    }

    autoanimate () {
        if (this.skipFrame) {
            this.skipFrame = false;
        } else {
            this.current++;

            if (this.current > this.UI.dots.length) {
                this.current = 1;
            }

            this.UI.dots.removeClass('is-active');
            this.UI.dots.eq(this.current - 1).addClass('is-active');
            this.current = parseInt(this.UI.dots.eq(this.current - 1).attr('data-index'), 10);
            this.UI.list.attr('data-current', this.current);
        }

        setTimeout(() => {
            this.autoanimate();
        }, 4000);
    }
}
